import axios from 'axios';

import { ListResponse, Response, ResponseArray } from '../../../../setup/axios/HttpResponse';
import { API_URL } from '../../../utils/common/constants';
import { _convertObjectToQuery } from '../../../utils/helpers';
import {
  ActiveUserParam,
  BusNotLinkedDriver,
  CheckStepAccountInfo,
  City,
  DispatchCenter,
  Driver,
  LinkedDispatcher,
  Nationality,
  SearchUserRequest,
  Skill,
  Team,
  UserInfo,
  UserModel,
  UsersTypeParams,
  Housing,
} from '../models';
import { OperationHoursAndMap } from '../models/OperationHoursAndMap';
import { TimeSlotWorkingDay } from '../../busy-time/models/BusyTime';
import { ImportError } from 'shared/BulkUpload';
import { Province } from 'app/modules/customers/models';

const userApi = {
  getUsers(body: SearchUserRequest): Promise<ListResponse<UserModel>> {
    // Remove empty housingId and provinceId from query params
    const queryBody = { ...body };
    if (!queryBody.housingIds || queryBody.housingIds.length === 0) {
      delete queryBody.housingIds;
    }
    if (!queryBody.provinceId || queryBody.provinceId === '') {
      delete queryBody.provinceId;
    }
    const url = `${API_URL}/api/v1/company-user/filter-users?${_convertObjectToQuery(queryBody)}`;
    return axios.get(url);
  },
  deleteEmployers(payload: string[]): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/users/employers/delete`;
    return axios.put(url, { ids: payload });
  },
  getAllNationality(): Promise<ResponseArray<Nationality>> {
    const url = `${API_URL}/api/v1/location/get-nationality`;
    return axios.get(url);
  },
  getAllLinkedDispatcher(): Promise<ResponseArray<LinkedDispatcher>> {
    const url = `${API_URL}/api/v1/company-user/get-dispatcher`;
    return axios.get(url);
  },
  getAllSkill(): Promise<ResponseArray<Skill>> {
    const url = `${API_URL}/api/v1/company-user/get-worker-skill`;
    return axios.get(url)
  },
  getAllCity(): Promise<ResponseArray<City>> {
    const url = `${API_URL}/api/v1/location/get-city`;
    return axios.get(url)
  },
  getAllProvince(): Promise<ResponseArray<Province>> {
    const url = `${API_URL}/api/v1/provine`;
    return axios.get(url)
  },
  getAllHousing(): Promise<ResponseArray<Housing>> {
    const url = `${API_URL}/api/v1/housing/get-all`;
    return axios.get(url);
  },
  getHousingByProvinceId(provinceId: string | number): Promise<ResponseArray<Housing>> {
    const url = `${API_URL}/api/v1/housing/province/${provinceId}`;
    return axios.get(url);
  },
  getAllTeams(params?: { isOnlyCentro: boolean }): Promise<ResponseArray<Team>> {
    const url = `${API_URL}/api/v1/users/get-sp-teams-active?${_convertObjectToQuery(params)}`;
    return axios.get(url)
  },
  getAllDispatchCenter(): Promise<ResponseArray<DispatchCenter>> {
    const url = `${API_URL}/api/v1/company-user/get-dispatch-centers`;
    return axios.get(url)
  },
  getAllDriver(): Promise<ResponseArray<Driver>> {
    const url = `${API_URL}/api/v1/company-user/get-drivers`;
    return axios.get(url)
  },
  getAlBusNotLinkedDriver(): Promise<ResponseArray<BusNotLinkedDriver>> {
    const url = `${API_URL}/api/v1/company-user/get-bus-not-linked-driver`;
    return axios.get(url)
  },
  getOperationHoursAndMaps(): Promise<ResponseArray<OperationHoursAndMap>> {
    const url = `${API_URL}/api/v1/company-user/get-operation-hours-map`;
    return axios.get(url)
  },
  createWorker(payload: FormData): Promise<Response<UserModel>> {
    const url = `${API_URL}/api/v1/company-user/create-worker`;
    return axios.post(url, payload, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  createDriver(payload: FormData): Promise<Response<UserModel>> {
    const url = `${API_URL}/api/v2/company-user/create-driver`;
    return axios.post(url, payload, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  createAdmin(payload: FormData): Promise<Response<UserModel>> {
    const url = `${API_URL}/api/v1/company-user/create-admin`;
    return axios.post(url, payload, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  createBus(payload: FormData): Promise<Response<UserModel>> {
    const url = `${API_URL}/api/v2/company-user/create-driver`;
    return axios.post(url, payload, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  checkExistUserInfo(params: CheckStepAccountInfo): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/company-user/check-exist-user-info?${_convertObjectToQuery(params)}`;
    return axios.get(url);
  },
  // Api active users
  activeUser(payload: ActiveUserParam): Promise<Response<UserModel>> {
    const url = `${API_URL}/api/v1/company-user/update-status`;
    return axios.patch(url, payload, { headers: { 'Content-Type': 'application/problem+json; charset=utf-8' } });
  },
  // Check if worker has active cluster assignments
  checkWorkerHasActiveCluster(workerId: string): Promise<ResponseArray<{dispatchId: number, nameEn: string, nameAr: string}>> {
    const url = `${API_URL}/api/v1/dispatch/check-worker-has-active-cluster?workerId=${workerId}`;
    return axios.get(url);
  },
  // Edit Users
  editUser(payload: FormData): Promise<Response<UserModel>> {
    const url = `${API_URL}/`;
    return axios.post(url, payload, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  // get all Admin
  getAllAdmin(body: UsersTypeParams): Promise<ListResponse<UserModel>> {
    const url = `${API_URL}/api/v1/company-user/users-type?${_convertObjectToQuery(body)}`;
    return axios.get(url);
  },
  // get all Admin
  getAllWorker(body: UsersTypeParams): Promise<ListResponse<UserModel>> {
    const url = `${API_URL}/api/v1/company-user/users-type?${_convertObjectToQuery(body)}`;
    return axios.get(url);
  },

  getUserById(id: string): Promise<Response<UserInfo>> {
    const url = `${API_URL}/api/v1/company-user/${id}`;
    return axios.get(url);
  },


  updateAdmin(payload: FormData): Promise<Response<UserModel>> {
    const url = `${API_URL}/api/v1/company-user/update-admin`;
    return axios.post(url, payload, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  updateTech(payload: FormData): Promise<Response<UserModel>> {
    const url = `${API_URL}/api/v2/company-user/update-driver`;
    return axios.post(url, payload, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  getAllWorkerWithSPLinked(body: UsersTypeParams): Promise<ListResponse<UserModel>> {
    const url = `${API_URL}/api/v1/company-user/get-worker-name`;
    return axios.get(url);
  },

  updateWorker(payload: FormData): Promise<Response<UserModel>> {
    const url = `${API_URL}/api/v1/company-user/update-worker`;
    return axios.post(url, payload, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  checkExistPhone(params: { userId?: string, phoneNumber?: string }): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/users/check-exist-phone?${_convertObjectToQuery(params)}`;
    return axios.get(url);
  },
  checkExistEmail(params: { userId?: string, email?: string }): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/users/check-exist-email?${_convertObjectToQuery(params)}`;
    return axios.get(url);
  },
  checkExistWorkerId(params: { userId?: string, workerId?: string }): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/users/check-exist-worker-id?${_convertObjectToQuery(params)}`;
    return axios.get(url);
  },

  // get time slots
  getTimeSlots(params: { lstSPId: string[], lstDateCheck: string[], timezone: number }): Promise<ResponseArray<TimeSlotWorkingDay>> {
    const url = `${API_URL}/api/v1/busy-time-bus/get-time-slot-working-day`;
    return axios.post(url, {
      ...params
    });
  },

  getBusyTimeDay(params: { spId: string, timezone: number }): Promise<ResponseArray<string>> {
    const url = `${API_URL}/api/v1/busy-time-bus/get-busy-time-by-day?${_convertObjectToQuery(params)}`;
    return axios.get(url);
  },

  updateBusyTime(payload: any): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/busy-time-bus/create`;
    return axios.post(url, payload);
  },

  resetAllBusyTime(spIds: string[]): Promise<Response<boolean>> {
    const url = `${API_URL}/api/v1/busy-time-bus/reset-all`;
    return axios.put(url, { SPId: spIds });
  },

  downloadUserTemplate(): Promise<Blob> {
    const url = `${API_URL}/api/v1/users/download-user-template`;
    return axios.get(url, { responseType: 'blob' });
  },

  importUsersFromExcel(payload: FormData): Promise<Response<ImportError[]>> {
    const url = `${API_URL}/api/v1/users/import-users-from-excel`;
    return axios.post(url, payload, { headers: { 'Content-Type': 'multipart/form-data', 'toast-message': 'false' } });
  },

  downloadWorkerTemplate(): Promise<Blob> {
    const url = `${API_URL}/api/v2/company-user/download-worker-template`;
    return axios.get(url, { responseType: 'blob' });
  },

  importWorkersFromExcel(payload: FormData): Promise<Response<ImportError[]>> {
    const url = `${API_URL}/api/v2/company-user/import-workers-from-excel`;
    return axios.post(url, payload, { headers: { 'Content-Type': 'multipart/form-data', 'toast-message': 'false' } });
  },

  downloadDriverTemplate(): Promise<Blob> {
    const url = `${API_URL}/api/v2/company-user/download-driver-template`;
    return axios.get(url, { responseType: 'blob' });
  },

  importDriversFromExcel(payload: FormData): Promise<Response<ImportError[]>> {
    const url = `${API_URL}/api/v2/company-user/import-drivers-from-excel`;
    return axios.post(url, payload, { headers: { 'Content-Type': 'multipart/form-data', 'toast-message': 'false' } });
  },
}

export { userApi }